const API_ENDPOINT = 'UserEmployeeProfileToDoTasks';

export const API_USER_EMPLOYEE_PROFILE_TODO_TASKS = {
  API_ENDPOINT,
  GET_ALL_DYNAMIC: `${API_ENDPOINT}/GetAllDynamic`,
  POST: `${API_ENDPOINT}/Create`,
  PATCH: (data: Pick<Components.Schemas.UserEmployeeProfileToDoTask, 'id'>) =>
    `${API_ENDPOINT}/Patch/${data.id}`,
  DELETE: (data: Pick<Components.Schemas.UserEmployeeProfileToDoTask, 'id'>) =>
    `${API_ENDPOINT}/Delete/${data.id}`,
  INSERT_BULK: `${API_ENDPOINT}/CreateUserEmployeeProfileToDoTaskBulk`,
};

export interface UserEmployeeProfileTodoTaskBulkInput {
  toDoTaskID: string;
  userEmployeeProfileIDs: string[];
}
